import { render } from "./GeneralVenue.vue?vue&type=template&id=27f11b3c&scoped=true"
import script from "./GeneralVenue.vue?vue&type=script&lang=js"
export * from "./GeneralVenue.vue?vue&type=script&lang=js"

import "./GeneralVenue.vue?vue&type=style&index=0&id=27f11b3c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f11b3c"]])

export default __exports__